import React, { useEffect, useRef, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  createSmeSchedules,
  getSmeSchedules,
  getSubjectEnrollmentId,
} from "../../../../redux/features/smeSlice";
import * as XLSX from "xlsx";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  getAddedTopics,
  getSubjectsUnderBatchId,
} from "../../../../redux/features/batchSlice";
const AddSchedule = ({
  dispatchdata,
  courseenrollmentId,
  dataParams,
  BatchID,
}) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, subjectEnrollId } = useSelector((state) => state.sme);
  const { subjects } = useSelector((state) => state.batch);
  const [excellConvertionLoading, setExcellConvertionLoading] = useState(false);
  const fileInputRef = useRef(null);

  const ValidationSchema = Yup.object().shape({
    subject_enrollment_id: Yup.string().required(
      "Subject Enroll Id is required"
    ),
    excelData: Yup.array()
      .of(
        Yup.object().shape({
          session_no: Yup.string().required("Session no is required"),
          chapter: Yup.string().required("Chapter is required"),
          // topic: Yup.string().required("Topic is required"),
          // objectives: Yup.string().required("Objectives are required"),
        })
      )
      .min(1, "Please upload at least one row in Excel"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      // session_no: "",
      // chapter: "",
      // topic: "",
      // objectives: "",
      // status: 0,
      subject_enrollment_id: "",
      excelData: [],
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      const data = values.excelData.map((item) => ({
        ...item,
        subject_enrollment_id: values.subject_enrollment_id,
      }));

      dispatch(createSmeSchedules({ data: data })).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          if (BatchID) {
            dispatch(getAddedTopics(dataParams));
          } else {
            dispatch(getSmeSchedules(dispatchdata));
          }
          setOpen(false);
          formik.resetForm();

          setOpen(false);
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
        }
      });
    },
  });

  useEffect(() => {
    if (open && courseenrollmentId) {
      dispatch(getSubjectEnrollmentId(courseenrollmentId));
    }
  }, [courseenrollmentId, open]);

  useEffect(() => {
    if (open && BatchID) {
      dispatch(getSubjectsUnderBatchId(BatchID));
    }
  }, [BatchID, open]);

  const handleCancel = () => {
    setOpen(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    formik.resetForm();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setExcellConvertionLoading(true);
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const binaryString = e.target.result;
          const workbook = XLSX.read(binaryString, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);
          formik.setFieldValue("excelData", json);
        } catch (error) {
          console.error("Error parsing Excel file:", error);
          formik.setFieldValue("excelData", []);
        } finally {
          setExcellConvertionLoading(false);
        }
      };
      reader.onerror = () => {
        console.error("File reading error");
        setExcellConvertionLoading(false);
      };
      reader.readAsBinaryString(file);
    }
  };

  const downloadSampleExcel = () => {
    const link = document.createElement("a");
    link.href = "/sheets/SessionsUploadStructure.xlsx";
    link.download = "SessionsUploadStructure.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <GlobalDialog
      title={"Add Schedule"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <AddButton size="medium" action={() => setOpen(true)}>
          Add Schedule
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  {!BatchID && (
                    <GlobalSelectField
                      options={{
                        formik,
                        name: "subject_enrollment_id",
                        label: "Subject Enrollment",
                        data: subjectEnrollId.data?.map((item) => ({
                          ...item,
                          course_name: `${item.course_name} - ${item.subject_name}`,
                        })),
                        keys: {
                          id: "subject_enrollment_id",
                          value: "course_name",
                        },
                      }}
                    />
                  )}
                  {BatchID && (
                    <GlobalSelectField
                      options={{
                        formik,
                        name: "subject_enrollment_id",
                        label: "Subject",
                        data: subjects,
                        keys: {
                          id: "subject_enrollment_id",
                          value: "subject_name",
                        },
                      }}
                    />
                  )}
                  <Box mb={1}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={downloadSampleExcel}
                    >
                      <Icon
                        icon="vscode-icons:file-type-excel2"
                        width="25"
                        height="25"
                      />
                      <Typography ml={"4px"} variant={"button"}>
                        Download Excell Structure
                      </Typography>
                    </Button>
                  </Box>
                  <Box>
                    <TextField
                      name="excelData"
                      inputRef={fileInputRef}
                      InputLabelProps={{ shrink: true }}
                      placeholder="Select an Excel File to Upload"
                      label="Select an Excel File to Upload"
                      variant="outlined"
                      type="file"
                      onChange={handleFileChange}
                      accept=".xlsx, .xls"
                      error={
                        formik.touched.excelData &&
                        Boolean(formik.errors.excelData)
                      }
                      helperText={
                        formik.touched.excelData && formik.errors.excelData
                          ? typeof formik.errors.excelData === "string"
                            ? formik.errors.excelData
                            : "Invalid data in Excel"
                          : ""
                      }
                    />
                  </Box>
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={handleCancel}>
                      Cancel
                    </CancelButton>
                    <SubmitButton
                      disabled={loading || excellConvertionLoading}
                      size="small"
                      type="submit"
                    >
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddSchedule;
